import { css } from '@emotion/react';
import { BrowseMentorsModalProps } from './types';
import { highTide, white } from 'styles/global_defaults/colors';
import { standardSpacing } from 'styles/global_defaults/scaffolding';

const BROWSE_MENTORS_HEADER_HEIGHT_PX = 89;

const browseMentorsHeaderStyles = css`
  flex-shrink: 0;
  height: ${BROWSE_MENTORS_HEADER_HEIGHT_PX}px;
  color: ${white};
  background-color: ${highTide};
  padding: ${standardSpacing}px;
`;

const BrowseMentorsHeader = ({
  title,
}: Pick<BrowseMentorsModalProps, 'title'>) => (
  <div
    css={browseMentorsHeaderStyles}
    className='header-lg bold condensed align-content-center'
  >
    {title}
  </div>
);

export default BrowseMentorsHeader;
